var map = {
	"./default-cover-img-1.jpg": [
		"+Zkz",
		28
	],
	"./default-cover-img-2.jpg": [
		"y+/X",
		29
	],
	"./default-cover-img-3.jpg": [
		"K88Q",
		30
	],
	"./default-cover-img-4.jpg": [
		"p5qs",
		31
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "tTF8";
module.exports = webpackAsyncContext;